export const TOGGLE_THEME = "TOGGLE_THEME";
export const SHOW_ERROR_MODAL = "SHOW_ERROR_MODAL";
export const SHOW_EXPIRED_MODAL = "SHOW_EXPIRED_MODAL";
export const SHOW_RETRY_MODAL = "SHOW_RETRY_MODAL";
export const HIDE_ERROR_MODAL = "HIDE_ERROR_MODAL";
export const HIDE_EXPIRED_MODAL = "HIDE_EXPIRED_MODAL";
export const HIDE_RETRY_MODAL = "HIDE_RETRY_MODAL";
export const TOGGLE_SHOW_MOBILE = "TOGGLE_SHOW_MOBILE";
export const TOGGLE_MASK_BALANCE = "TOGGLE_MASK_BALANCE";
export const TOGGLE_SIDE_NAV = "TOGGLE_SIDE_NAV";
export const HIDE_SIDE_NAV = "HIDE_SIDE_NAV";
export const DESTROY_SESSION = "DESTROY_SESSION"
